import React from "react";

export default function Tile(props) {
  return (
    <a href={props.link} target="_blank" rel="noreferrer">
      <img referrerPolicy="no-referrer" className={props.className} src={props.source} alt="link icon" />
    </a>
  );
}
